import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_bomzcs63: FaireBrandEntity = {
  token: "b_bomzcs63",
  type: "brand",
  name: "Hachette Book Group",
  avatarUrl: "https://cdn.faire.com/fastly/2a97cff36ebd2fa7e367f1d828a7861c241b545cc551ea0aa70867bb166a0bd0.webp",
  bannerUrl: "https://cdn.faire.com/fastly/5ad1786e52e361a1f64eec1b0470bf5bb6532874f6a66d415665157f97f65357.png",
  logoUrl: "https://cdn.faire.com/fastly/2a97cff36ebd2fa7e367f1d828a7861c241b545cc551ea0aa70867bb166a0bd0.webp",
  heroImageUrl: "https://cdn.faire.com/fastly/5ad1786e52e361a1f64eec1b0470bf5bb6532874f6a66d415665157f97f65357.png",
  location: "New York, NY, USA",
  minimumOrderDollars: 150,
  rating: 4.8,
  reviewCount: 526,
  isTopShop: true,
  isInsider: true,
  description: "Hachette Book Group (HBG) is the third largest trade publisher in the world, made up of dozens of esteemed imprints. We publish in a wide range of topics and formats, including Workman’s Original Page-a-Day® Calendars, Running Press’ Mini Kits, Artisan’s quality illustrated books, and Summersdale’s trend-driven gift books. We offer award-winning picture books from Little, Brown Books for Young Readers, educational bestsellers from Workman Kids, and innovative content from WorthyKids, Kids Can Press, and Algonquin Young Readers. Discover the top travel guides, gardening books, manga and religious literature from HBG. We are also the home to bestselling fiction and nonfiction authors Elin Hilderbrand, Malcolm Gladwell, Stephanie Meyer, James Patterson, David Sedaris, and David Baldacci.",
  meta: {
    source: "api",
    importedAt: "2026-10-28T20:56:46.411Z",
    importedBy: "entity-db-cli"
  }
};
